import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersCoServices } from '../../services';

/*
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
*/

@Component({
    selector: 'page-orders-table-info-print',
    templateUrl: 'orders-table-info-print.html',
})
export class OrdersTableInfoPrintPage {
    footer: any;
    header: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public ordersCoServices: OrdersCoServices) {
            
    }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table-info-print/orders-table-info-print.ts